import {useState} from 'react';

import More from '@/root/components/More';
import MyCardItem from '@/root/components/MyCardItem';
import {ROUTES} from '@/root/constants/routes';
import {HomeCardWithTitle} from '@/root/models/home';
import {useUiStore} from '@/root/stores/ui';

import {TIARA_ACTION, TIARA_PAGE_NAME} from '@/shared/constants/tiara';
import useAdvancedNavigate from '@/shared/hooks/useAdvancedNavigate';
import useTiara from '@/shared/hooks/useTiara';

type Props = {
  cards: HomeCardWithTitle[];
};

const MIN_LENGTH = 4;

const MyCards = ({cards}: Props) => {
  const navigate = useAdvancedNavigate();
  const {setIsOpenedMoreMyCard, isOpenedMoreMyCard, setIsFromHome} = useUiStore();
  const [visibleCount, setVisibleCount] = useState(isOpenedMoreMyCard ? cards.length : MIN_LENGTH);
  const {trackEvent} = useTiara({pageName: TIARA_PAGE_NAME.HOME});

  const onClickMore = () => {
    setIsOpenedMoreMyCard(true);
    setVisibleCount(cards.length);
    trackEvent({action: TIARA_ACTION.CARD_MORE_VIEW_CLICK});
  };

  const onClickCard = (clickedCard: HomeCardWithTitle) => {
    const [card] = clickedCard.groupedCards; // 첫번째가 대표 카드
    trackEvent({
      action: TIARA_ACTION.MY_CARD_CLICK,
      customProps: {
        partner_name: card.title,
        package_id: clickedCard.key,
        status: card.expired ? 'expiration' : 'valid'
      }
    });
    setIsFromHome(true);
    navigate(
      {
        pathname: ROUTES.CARD_GROUP
      },
      {
        pathParams: {
          groupCode: clickedCard.groupCode
        },
        transitionDirection: 'forward'
      }
    );
  };

  const onClickEdit = () => {
    trackEvent({action: TIARA_ACTION.EDIT_CLICK});
    navigate(ROUTES.HOME_DELETE);
  };

  if (!cards.length) return null;

  return (
    <>
      <div className="box_head">
        <h3 className="tit_section type2">
          <span role="text">
            <span className="txt_tit">내 카드</span>
          </span>
        </h3>
        <button type="button" className="btn_util" onClick={onClickEdit}>
          편집 <span className="icon icon_arr_right_type8" />
        </button>
      </div>
      <strong className="screen_out">발급된 카드 목록</strong>
      <ul className="list_card">
        {cards.slice(0, visibleCount).map((card, index) => (
          <MyCardItem key={`${card.key}-${index}`} card={card} onClickCard={onClickCard} />
        ))}
      </ul>
      <More show={cards.length > visibleCount} text="카드 더보기" onClickMore={onClickMore} direction="down" />
    </>
  );
};

export default MyCards;
